/**
 * 庭审状态常量
 * 与后端HearingStatusConstant保持一致
 */
export const HEARING_STATUS = {
  // 未开始
  NOT_STARTED: 1,
  // 进行中
  IN_PROGRESS: 2,
  // 休庭中
  PAUSED: 3,
  // 已结束
  ENDED: 4,
  // 预备开庭
  PREPARING: 5
};

/**
 * 庭审状态名称映射
 */
export const HEARING_STATUS_NAME = {
  [HEARING_STATUS.NOT_STARTED]: '未开始',
  [HEARING_STATUS.IN_PROGRESS]: '进行中',
  [HEARING_STATUS.PAUSED]: '暂停中',
  [HEARING_STATUS.ENDED]: '已结束',
  [HEARING_STATUS.PREPARING]: '预备中'
};

/**
 * 获取状态名称
 * @param {number} status 状态值
 * @returns {string} 状态名称
 */
export function getStatusName(status) {
  return HEARING_STATUS_NAME[status] || '未知状态';
}

/**
 * 判断是否为有效状态
 * @param {number} status 状态值
 * @returns {boolean} 是否有效
 */
export function isValidStatus(status) {
  return Object.values(HEARING_STATUS).includes(status);
}
